import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import * as React from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import * as locales from "@mui/material/locale";

type SupportedLocales = keyof typeof locales;
interface RequireType {
  children: any | React.ReactNode | React.ReactElement;
}

const TablePaginationLocalizationProvider: React.FC<RequireType> = ({
  children,
}) => {
  const { i18n } = useTranslation();
  const theme = useTheme();
  const [locale, setLocale] = React.useState<SupportedLocales>("enUS");

  const themeWithLocale = React.useMemo(
    () => createTheme(theme, locales[locale]),
    [locale, theme],
  );

  useEffect(() => {
    switch (i18n.language) {
      case "en": // Error: Fallthrough case in switch.
        setLocale("enUS");
        break;
      case "fr":
        setLocale("frFR");
        break;
      case "ar":
        setLocale("arSA");
        break;
    }
  }, [i18n, i18n.language]);

  return <ThemeProvider theme={themeWithLocale}>{children}</ThemeProvider>;
};

export default TablePaginationLocalizationProvider;
